<template>
  <el-card style="min-height: 45rem">
    <el-table :data="list">
      <el-table-column prop="id" label="编号" width="80" show-overflow-tooltip></el-table-column>
      <el-table-column label="缩略图" width="80" show-overflow-tooltip>
        <template v-slot="s">
          <img :src="s.row.pic | tomedia" style="width: 3rem;height: 3rem;border-radius: .5rem">
        </template>
      </el-table-column>
      <el-table-column prop="title" label="名称" show-overflow-tooltip></el-table-column>
      <el-table-column :formatter="e=>e.status ? '已上架' : '未上架'"  label="上架" show-overflow-tooltip></el-table-column>
      <el-table-column prop="points" label="积分" show-overflow-tooltip></el-table-column>
      <el-table-column prop="fee" label="价格" show-overflow-tooltip></el-table-column>
      <el-table-column prop="stock" label="库存" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sales" label="销量" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot="header">
          <el-button @click="$router.push({
          name:'shop-plugin-points-mall-goods-edit'
          })" type="primary">添加商品</el-button>
        </template>
        <template v-slot="s">
          <el-button @click="$router.push({
          name:'shop-plugin-points-mall-goods-edit',
          query:{
            id:s.row.id
          }
          })" type="primary">编辑</el-button>
          <el-button @click="del(s.row)" type="danger">删除</el-button>
        </template>
      </el-table-column>
      <template #append>
        <el-pagination style="padding: .5rem" background layout="total,prev, pager,next"
                       :total="total" :page-size="15" :current-page="page" @current-change="pageChange">
        </el-pagination>
      </template>
    </el-table>
  </el-card>
</template>

<script>
export default {
  name: "list",
  data(){
    return{
      list:[],
      page:1,
      total:0,
    }
  },
  mounted() {
    this.load();
  },
  methods:{
    del({id}){
      this.$u.api.shop.plugin.pointsMall.goodsDel({id}).then(()=>{
        this.$message.success("操作成功");
        this.load();
      })
    },
    pageChange(e){
      this.page = e;
      this.load();
    },
    load(){
      this.$u.api.shop.plugin.pointsMall.goodsSearch({page:this.page}).then((res)=>{
        this.list = res.list;
        this.total = res.total;
      })
    },
  },
}
</script>

<style scoped>

</style>